import React from 'react';
import { Translate } from 'react-jhipster';
import { Button, Modal, ModalBody, Row, ModalHeader, ModalFooter, Spinner, Alert } from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import '../register.scss';
import { IRootState } from 'app/shared/reducers';
import { connect } from 'react-redux';
import { KEY_STORAGE, SUCCESS } from 'app/config/constants';
import { isEmpty } from 'app/shared/util/utilities';
import { Storage } from 'react-jhipster';

export interface IModalSmartCAProps extends StateProps, DispatchProps {
  showModal: boolean;
  message: string;
}
export interface IModalSmartCAState {}

class ModalSmartCA extends React.Component<IModalSmartCAProps, IModalSmartCAState> {
  state: IModalSmartCAState = {};
  componentWillReceiveProps(nextProps) {}
  render() {
    return (
      <div>
        <Modal isOpen={this.props.showModal} backdrop="static" centered>
          <ModalBody className="padding-modal-body">
            <Alert id="myAlert" color="danger" isOpen={this.props.message !== '' ? true : false}>
              <div style={{ textAlign: 'center' }}>{this.props.message}</div>
            </Alert>
            <div style={{ textAlign: 'center' }}>
              <label style={{ fontWeight: 'bold', marginTop: '10px' }}>Xác thực SmartCA</label>
              <label style={{ fontSize: '16px' }}>Vui lòng kiểm tra và xác nhận giao dịch trên ứng dụng di động!</label>
              {/* <label>Thời gian còn lại: 30s</label> */}
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({});

const mapDispatchToProps = {};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalSmartCA);
